import React, { useMemo } from "react";
import { Skeleton } from "@mantine/core";
import { Bar } from "react-chartjs-2";
import { loadingStates } from "../../utilities/utilities";

const AGE_BUCKETS = ["0-3", "4-7", "8-10", "10+"];

const BAR_COLORS = {
  "0-3": "rgb(70, 189, 225)",
  "4-7": "rgb(70, 189, 225)",
  "8-10": "#FDAE38",
  "10+": "#F75435",
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Agreements",
      },
      grid: {
        display: false,
      },
      ticks: {
        precision: 0,
      },
    },
    x: {
      title: {
        display: true,
        text: "Days",
      },
      grid: {
        display: false,
      },
    },
  },
};

function AgreementGraph2({ configs }) {
  const isLoading = configs.loading === loadingStates.LOADING;

  const { labels, dataValues, backgroundColors } = useMemo(() => {
    const groupedData = {
      "0-3": 0,
      "4-7": 0,
      "8-10": 0,
      "10+": 0,
    };

    configs?.data?.agreementsAgeing?.forEach((item) => {
      const ageing = parseInt(item.ageing, 10);
      if (Number.isNaN(ageing)) return;

      if (ageing <= 3) {
        groupedData["0-3"] += item.count;
      } else if (ageing <= 7) {
        groupedData["4-7"] += item.count;
      } else if (ageing <= 10) {
        groupedData["8-10"] += item.count;
      } else {
        groupedData["10+"] += item.count;
      }
    });

    return {
      labels: AGE_BUCKETS,
      dataValues: AGE_BUCKETS.map((key) => groupedData[key]),
      backgroundColors: AGE_BUCKETS.map((key) => BAR_COLORS[key]),
    };
  }, [configs?.data?.agreementsAgeing]);

  return (
    <div className="mx-auto mt-4 w-full max-w-2xl">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h3 className="mb-3 text-sm font-semibold capitalize text-gray-700">
          Ageing (days)
        </h3>

        {isLoading ? (
          <Skeleton height={220} radius="md" />
        ) : (
          <div className="h-56 w-full">
            <Bar
              data={{
                labels,
                datasets: [
                  {
                    label: "Ageing",
                    backgroundColor: backgroundColors,
                    barThickness: 32,
                    borderRadius: 6,
                    data: dataValues,
                  },
                ],
              }}
              options={chartOptions}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AgreementGraph2;
